module.exports = __webpack_public_path__ + "aea5869d65e34f6a626487d1553d0a2b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-blue-s.png
// module id = 1333
// module chunks = 0